import * as S from '@effect/schema/Schema';
export var TermsAndConditionsBlockConfig = S.struct({
  typename: S.literal('TermsAndConditionsBlock'),
  id: S.string,
  hash: S.string,
  body: S.nullable(S.string)
});